export default "__VITE_PUBLIC_ASSET__5c9a3cfc__"